import { createContext } from 'react';

import { PortfolioEventTypes, SSEEvent } from '@hcs/types';
import { ConnectionStatus } from '@hcs/types';

type PortfolioEventMessageListener = (e: SSEEvent<PortfolioEventTypes>) => void;

export const PortfolioApiEventsContext = createContext({
  subscribeToServerSentEvents: (params: {
    callbackId: string;
    componentId: string;
    onMessage: PortfolioEventMessageListener;
  }) => {
    return;
  },
  unsubscribeFromServerSentEvents: (params: {
    callbackId: string;
    componentId: string;
  }) => {
    return;
  },
  getConnectionStatus: (): ConnectionStatus => ConnectionStatus.Disconnected,
});
